import { Component, OnInit} from '@angular/core';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { page }  from '../class/status';

@Component({
  selector: 'app-logview',
  templateUrl: './logview.component.html',
  styleUrls: ['./logview.component.css'],
})

export class LogviewComponent implements OnInit {

  constructor(
      public httpClient: HttpClient,
  ) { }

  ngOnInit(): void {
    this.deviceLocalDataList();
  }

  loading: boolean = false;
  nowTabPage = '1';
  selectedJsonData: any = {}; // 儲存要顯示的 JSON
  deviceLocalSelected: string = '-1';
  logSelected: string = '全部';
  selectOptions: any = [
    {id:'-1',name:'全部'},
    {id:'0',name:'api過慢紀錄'},
    {id:'1',name:'通聯紀錄'},
    {id:'2',name:'網路監測'},
    {id:'3',name:'聊天室通訊行為追蹤'},
    {id:'4',name:'直播語聊通聯'}
  ]
  searchAction: string = '';
  searchUserID: string = '';
  
  logDate:any = {start:'', end:''};
  timeSet = [{ type:1 , name: "過去7天", num: -7 }, { type:1 , name: "昨天", num: -1 },{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 }];

  rowCountOptions: number[] = [10, 20, 50, 100];  // 可選的行數

  deviceLocalDataPageObj: page = { page: 0, count: 10, total_count: 0 }; // 每頁 10 筆
  deviceLocalDataPageObjStr: string = JSON.parse(JSON.stringify(this.deviceLocalDataPageObj));
  deviceLocalData: any =[];
  deviceLocalDataTcontent = [
    { title: '🏷️呼叫用戶', content: 'user_info'}, // 員工名稱
    { title: '®️動作類型', content: 'action' }, // 總申請件數
    { title: '📄JSON參數', content: 'json',type: 4 }, // 取消件數
    { title: '📅建立日期', content: 'create_dt' }, // 拒絕件數
    { title: '🈸操作', content: '0',type: 5 }, // 待審件數
  ];

  api_logList: any =[];
  api_logDataPageObj: page = { page: 0, count: 10, total_count: 0 }; // 每頁 10 筆
  api_logDataPageObjStr: string = JSON.parse(JSON.stringify(this.api_logDataPageObj));
  api_logData: any =[];
  api_logTcontent = [
    { title: '🏷️呼叫用戶', content: 'user_info'}, // 員工名稱
    { title: '®️功能api', content: 'path' }, // 總申請件數
    { title: '📄JSON參數', content: 'post_value', type: 4 }, // 待審件數
    { title: '📕執行結果', content: 'result_status' }, // 取消件數
    { title: '⏱️時間', content: 'run_time' }, // 拒絕件數
    { title: '📅建立日期', content: 'create_dt' }, // 拒絕件數
    { title: '🈸操作', content: '0',type: 5 }, // 待審件數
  ];

  selectTab(tab: string) {
    this.nowTabPage = tab;
  }

  
  HandleRangeSelected( value: any ): void {
    let eventDate = value.event;
    this.logDate = { start: '', end: '' };
        
    if(eventDate?.startDate){
        this.logDate.start =  moment(eventDate.startDate).format('YYYY-MM-DD')
        this.logDate.end =  moment(eventDate.endDate).format('YYYY-MM-DD')    
    }else{
        this.logDate.start =  '';
        this.logDate.end =  '';
    }

    // console.log("選擇的日期範圍:", this.logDate);
  }

  ShowDatePickered(){
    this.logDate.start =  '';
    this.logDate.end =  '';

    // console.log("日期選擇器被開啟，重置日期並重新查詢");
  }

//---------------------------------
  deviceLocalDataList(){
    this.loading = true;

    const body ={
      page: this.deviceLocalDataPageObj.page,
      count: this.deviceLocalDataPageObj.count,
      searchUserID: this.searchUserID,
      action: this.deviceLocalSelected,
      logDate: this.logDate, 
      type: this.nowTabPage,
    };

    this.httpClient.post<any>("/log/log_view.php", body).subscribe(res => {
      this.loading = false;
      if(res.status){
        if(parseInt(res.total_count, 10) == 0){
          this.deviceLocalDataPageObj.total_count = 0
          this.deviceLocalDataPageObj.page = 0
          this.deviceLocalData = [];
        }else{
          this.deviceLocalData = res.data;
          this.deviceLocalDataPageObj.total_count = parseInt(res.total_count, 10) || 0;
          this.deviceLocalDataPageObjStr = JSON.parse(JSON.stringify(this.deviceLocalDataPageObj));
  
          // ✅ 確保 `json` 是有效的 JSON
          for (let item of this.deviceLocalData) {
            try {
              if (typeof item.json === "string") {
  
                // **解析外層 JSON**
                item.json = JSON.parse(item.json);
  
                // **如果 traceInfo 是字串，也要再解析**
                if (item.json.traceInfo && typeof item.json.traceInfo === "string") {
                  item.json.traceInfo = JSON.parse(item.json.traceInfo[0]);
                }
              }
            } catch (e) {
              console.error("JSON 解析失敗:", e);
              item.json = null;
            }
  
             // ✅ 直接使用 selectOptions 陣列來查找對應的名稱
             const actionItem = this.selectOptions.find(option => option.id === item.action);
             item.action = actionItem ? actionItem.name : `未知類型 (${item.action})`;
          }
  
          // ✅ 選擇第一筆 JSON 顯示
          this.selectedJsonData = this.deviceLocalData.length > 0 ? this.deviceLocalData[0].json : null;
        }
      }
      else{
        this.deviceLocalDataPageObj.total_count = 0
        this.deviceLocalData = [];
      }
    });
  }

  deviceHandleJsonData(jsonDataIndex: number) { //接收子元件的參數
    this.selectedJsonData = this.deviceLocalData.length > 0 ? this.deviceLocalData[jsonDataIndex].json : null;
  }

  deviceLocalDataCallBack(pageobj:page){
    if(JSON.stringify(this.deviceLocalDataPageObj) != JSON.stringify(pageobj)){
      this.deviceLocalDataPageObj = pageobj;
      this.deviceLocalDataList();
    }
  }

  deviceLocalDataHandleRangeSelected( value: any ): void {
    this.HandleRangeSelected(value);
    this.deviceLocalDataList();
  }

  deviceLocalDataShowDatePickered(){
    this.ShowDatePickered();
    this.deviceLocalDataList();
  }

  //-------------------------------------------
  
  apiLogDataList(){
    this.loading = true;

    const body ={
      page: this.api_logDataPageObj.page,
      count: this.api_logDataPageObj.count,
      searchUserID: this.searchUserID,
      path: this.logSelected,
      logDate: this.logDate, 
      type: this.nowTabPage,
    }; 
    this.httpClient.post<any>("/log/log_view.php", body).subscribe(res => {
      this.loading = false;
      if(res.status){
        if(parseInt(res.total_count, 10) == 0){
          console.log("123456789");
          this.api_logDataPageObj.total_count = 0
          this.api_logDataPageObj.page = 0
          this.api_logData = [];
        }else{
          
        this.api_logData = res.data;
        this.api_logDataPageObj.total_count = parseInt(res.total_count, 10) || 0;
        this.api_logDataPageObjStr = JSON.parse(JSON.stringify(this.api_logDataPageObj));
        this.api_logList = [{ id: -1, path: "全部" }, ...(Array.isArray(res.selectList) ? res.selectList : [])];


        // ✅ 確保 `json` 是有效的 JSON
        for (let item of this.api_logData) {
          try {
            if (typeof item.post_value === "string") {

              // **解析外層 JSON**
              item.post_value = JSON.parse(item.post_value);
            }
          } catch (e) {
            console.error("JSON 解析失敗:", e);
            item.post_value = null;
          }

           // ✅ 直接使用 selectOptions 陣列來查找對應的名稱
           const actionItem = this.selectOptions.find(option => option.id === item.action);
           item.action = actionItem ? actionItem.name : `未知類型 (${item.action})`;
        }

        // ✅ 選擇第一筆 JSON 顯示
        this.selectedJsonData = this.api_logData.length > 0 ? this.api_logData[0].post_value : {};
        }
      }
      else{
        this.api_logDataPageObj.total_count = 0
        this.api_logData = [];
      }
    });
  }

  apiLogHandleJsonData(jsonDataIndex: number) { //接收子元件的參數
    this.selectedJsonData = this.api_logData.length > 0 ? this.api_logData[jsonDataIndex].post_value : {};
  }

  apiLogDataCallBack(pageobj: page){
    if(this.api_logDataPageObj.page !== pageobj.page || this.api_logDataPageObj.count !== pageobj.count){
      this.api_logDataPageObj = pageobj;
      this.apiLogDataList();
    }
  }

  apiLogDataHandleRangeSelected( value: any ): void {
    console.log(555)
    this.HandleRangeSelected(value);
    console.log(666);
    this.apiLogDataList();
  }

  dapiLogDataShowDatePickered(){
    this.ShowDatePickered();
    console.log(777);
    this.apiLogDataList();
  }

}
